module.exports = __webpack_public_path__ + "img/Worker.ebfcb71f.svg";